/**
 * The colour a CSS expression computes to inside `host`, as `rgba()`.
 * The theme tokens are `oklch()` and `color-mix()`, which neither ECharts'
 * colour parser nor an agent's HTML page (a separate document that cannot
 * see the app's variables) can resolve; a 1×1 canvas converts whatever the
 * browser resolved into plain channels. Used by the ```chart theme and the
 * interactive page theme.
 */
export function resolveThemeColor(host: HTMLElement, expression: string, fallback: string): string {
  const probe = document.createElement("span");
  probe.style.color = expression;
  probe.style.display = "none";
  host.append(probe);
  const computed = getComputedStyle(probe).color;
  probe.remove();
  const canvas = document.createElement("canvas");
  canvas.width = 1;
  canvas.height = 1;
  const context = canvas.getContext("2d", { willReadFrequently: true });
  if (!context || !computed) return fallback;
  context.clearRect(0, 0, 1, 1);
  context.fillStyle = computed;
  context.fillRect(0, 0, 1, 1);
  const [red, green, blue, alpha] = context.getImageData(0, 0, 1, 1).data;
  if (alpha === undefined || alpha === 0) return fallback;
  return `rgba(${red}, ${green}, ${blue}, ${Math.round((alpha / 255) * 100) / 100})`;
}
